import React, { Component } from "react"
import parse from "html-react-parser"
import { GatsbyImage } from "gatsby-plugin-image"
import { ArrowLeft, Close } from "./icons"
import useOfficesQuery from "../hooks/use-offices-query"
import Select from "react-select"

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class ContactForm extends Component {
  constructor(props) {
    super(props)
    this.form = React.createRef()
    this.state = {
      popup: true,
      alerts: "off",
      office: this.props.office ? this.props.office : 'Office Not Selected',
      officeEmail: this.props.email ? this.props.email : 'property@ch.com.au',
    }
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    // https://zapier.com/editor/190552907/published/190552908
    fetch(`https://hooks.zapier.com/hooks/catch/2181815/3us6kmi/`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        ...this.state,
      }),
    })
      .then(() => {
        this.setState({ result: "success" })
      })
      .catch((error) => this.setState({ result: "fail", msg: error }))
  }

  _selectChange = (option) => {
    this.setState({
      ...this.state,
      office: option.label,
      officeEmail: option.value,
    })
  }

  render() {
    let props = {
      ref: this.form,
      name: "contact",
      className: "form",
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === "success") {
      return (
        <div className={`modal${this.state.popup ? " active" : ""}`}>
          <div
            className="modal__close-bg"
            onClick={() => this.setState({ popup: false })}
          />
          <div className="modal__inner">
            <button
              className="modal__close"
              onClick={() => this.setState({ popup: false })}
            >
              <Close color="#000000" />
            </button>
            <div className="modal__wrapper">
              <div className="modal__thank">
                <h2>
                  Your message has been sent.
                  <br />
                  Thanks for enquiring, someone from our team will be in touch shortly.
                </h2>
                <p></p>
              </div>
            </div>
          </div>
        </div>
      )
    }
    return (
      <form {...props}>
        <div className="form__row">
          <div className="form__select">
            <label htmlFor="officeList">
              <span>Office</span>
            </label>
            {!this.props.office && (
              <Select
                options={this.props.officeOptions}
                onChange={this._selectChange}
                openMenuOnFocus={true}
                isSearchable={false}
                id="officeList"
                name="officeList"
                value={this.office}
                placeholder="Please select"
                className="react-select-container"
                classNamePrefix="react-select"
                required
              />
            )}
          </div>
        </div>
        <div className="form__row form__row--double">
          <div className="form__radio">
            <input
              type="radio"
              name="help"
              value="Property Enquiry"
              id="property"
              onChange={this.handleChange}
            />
            <label htmlFor="property">
              <span>Property Enquiry</span>
            </label>
          </div>

          <div className="form__radio">
            <input
              type="radio"
              name="help"
              value="General Enquiry"
              id="general"
              onChange={this.handleChange}
            />
            <label htmlFor="general">
              <span>General Enquiry (please specify)</span>
            </label>
          </div>

          <div className="form__radio">
            <input
              type="radio"
              name="help"
              value="Tenant Enquiry"
              id="tenant"
              onChange={this.handleChange}
            />
            <label htmlFor="tenant">
              <span>Tenant Enquiry</span>
            </label>
          </div>
        </div>

        <div className="form__row">
          <label>Message</label>
          <textarea name="message" required onChange={this.handleChange} />
        </div>

        <div className="form__row form__row--double">
          <div className="form__item">
            <label htmlFor="email">First Name</label>
            <input
              type="text"
              name="first_name"
              onChange={this.handleChange}
              required
            />
          </div>
          <div className="form__item">
            <label htmlFor="email">Last Name</label>
            <input
              type="text"
              name="last_name"
              onChange={this.handleChange}
              required
            />
          </div>
        </div>

        <div className="form__row form__row--double">
          <div className="form__item">
            <label htmlFor="email"> Email</label>
            <input
              type="email"
              name="email"
              onChange={this.handleChange}
              required
            />
          </div>
          <div className="form__item">
            <label htmlFor="phone">Contact Number</label>
            <input
              type="text"
              name="phone"
              onChange={this.handleChange}
              required
            />
          </div>
        </div>

        <div className="form__row form__row--submit">
          {/* 
          <div className='form__checkbox'>
            <input type='checkbox' name='alerts' id='alerts' onChange={this.handleChange}/>
            <label htmlFor='alerts'><span>Yes, I'd like to receive email alerts about { this.props.office && <>{parse(this.props.office)}</> } properties</span></label>
          </div> 
          */}
          <button type="submit" className="btn" style={{ marginLeft: "auto" }}>
            <span>Send Enquiry</span>
          </button>
        </div>
      </form>
    )
  }
}

const Contact = ({ title, image }) => {
  const [office, setOffice] = React.useState("")
  const [email, setEmail] = React.useState("")
  const [officeOptions, setOfficeOptions] = React.useState([])

  const allWpOffice = useOfficesQuery()

  React.useEffect(() => {
    // get query string from url inside hook
    const urlParams = new URLSearchParams(window && window.location.search)
    const officeName = urlParams.get("office")
    const email = urlParams.get("email")
    if (officeName) setOffice(officeName)
    if (email) setEmail(email)
  }, [office, allWpOffice])

  React.useEffect(() => {
    if (allWpOffice && allWpOffice.length)
      setOfficeOptions(
        allWpOffice.map((office) => {
          return { label: office.title, value: office.officeDetails.email }
        })
      )
  }, [allWpOffice])

  return (
    <section className="contact">
      <div className="contact__back">
        <button onClick={() => window && window.history.back()}>
          <ArrowLeft color="#0F2130" />
          Back
        </button>

        {title && <h1>{title}</h1>}
        {office && <h2>{parse(office)}</h2>}
      </div>

      <div className="contact__inner">
        <div className="contact__form">
          {title && <h1>{title}</h1>}
          {office && <h2>{parse(office)}</h2>}

          <ContactForm
            email={email}
            office={office}
            officeOptions={officeOptions}
          />
        </div>

        <div className="contact__image">
          {image?.localFile && (
            <GatsbyImage
              image={image.localFile.childImageSharp.gatsbyImageData}
              alt=""
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default Contact
